import "./DeployDelivery.css";
import img from "../deployassets/deploydelivery.png";
import checkimg from "../deployassets/checkimg.png";

export default function DeployDelivery() {
  const cardsData = [
    {
      title: "Automated Deployment Pipelines",
      description:
        "We design end-to-end deployment pipelines that automatically deliver code from development to staging and production environments, reducing manual intervention and errors.",
    },
    {
      title: "CI/CD Integration",
      description:
        "Seamless integration with CI/CD tools like Jenkins, GitHub Actions, and GitLab to enable faster and more reliable releases.",
    },
    {
      title: "Environment Management",
      description:
        "Consistent configuration across development, staging, and production environments to avoid deployment mismatches.",
    },
    {
      title: "Rollback & Recovery",
      description:
        "Automated rollback mechanisms to quickly recover from failed deployments with minimal downtime.",
    },
    {
      title: "Monitoring & Alerts",
      description:
        "Real-time monitoring and alerting to track deployment health and detect issues early.",
    },
  ];

  return (
    <div id="deploy-delivery" className="outsourcemainclass">
      <div className="left">
        <img src={img} alt="error" />
        <div className="content-head">
          <h2 className="heading">
            Our Continuous Delivery & Deployment Capabilities
          </h2>
          <p className="subheading">
            Automated CD solutions designed to deliver reliable, controlled, and
            consistent software releases across multiple environments with
            minimal risk.
          </p>
        </div>
      </div>

      <div className="right">
        <div className="cards">
          {cardsData.map((card, index) => (
            <div className="card" key={index}>
              <img src={checkimg} alt="check" />
              <div className="content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
